






















import {Vue, Component, Watch, Prop} from "vue-property-decorator";

@Component
export default class HowToHeader extends Vue {
    @Prop() private stepNumber!: any;
    @Prop() private title!: any;
    @Prop() private subTitle!: any;
    @Prop() private sectionIntro!: any;
    @Prop() private subText!: any;
}
